import React__default from 'react';
import { loggedMenuItemsIcons } from '../icons.js';
var GoBack = function GoBack(_ref) {
  var onGoBackClick = _ref.onGoBackClick;
  var handleClick = function handleClick() {
    if (!!onGoBackClick) onGoBackClick();
  };
  return /* @__PURE__ */React__default.createElement("button", {
    className: "header-cp__panel-left__back",
    onClick: handleClick,
    "aria-label": "Voltar para p\xE1gina anterior"
  }, /* @__PURE__ */React__default.createElement("span", {
    className: "header-cp__panel-left__back__icon",
    dangerouslySetInnerHTML: {
      __html: loggedMenuItemsIcons.goBack
    }
  }));
};
export { GoBack as default };